module.exports = __webpack_public_path__ + "img/ticket1.4a9a552f.png";